import { render, staticRenderFns } from "./DepartmentSearchModal.vue?vue&type=template&id=0bcd68b7&"
import script from "./DepartmentSearchModal.vue?vue&type=script&lang=ts&"
export * from "./DepartmentSearchModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports